import { render, staticRenderFns } from "./FilaAtendimentoChat.vue?vue&type=template&id=f4679796&scoped=true&"
import script from "./FilaAtendimentoChat.vue?vue&type=script&lang=js&"
export * from "./FilaAtendimentoChat.vue?vue&type=script&lang=js&"
import style0 from "./FilaAtendimentoChat.vue?vue&type=style&index=0&id=f4679796&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4679796",
  null
  
)

export default component.exports